var __typeError = (msg) => {
    throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

document.addEventListener("DOMContentLoaded", function () {
    // External Links Opener
    const links = document.links;
    for (let i = 0; i < links.length; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = "_blank";
            links[i].rel = "noreferrer noopener";
        }
    }

    // Save UTM / tracking parameters to cookies (2 days)
    const TRACKING_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid', 'msclkid', 'twclid', 'li_fat_id', 'dclid', 'gbraid', 'wbraid'];
    const urlParams = new URLSearchParams(window.location.search);
    const cookieMaxAge = 60 * 60 * 24 * 2; // 2 days
    TRACKING_PARAMS.forEach(param => {
        const value = urlParams.get(param);
        if (value) {
            document.cookie = `param_${param}=${encodeURIComponent(value)}; max-age=${cookieMaxAge}; path=/; SameSite=Lax`;
        }
    });
})

function throttle(callback) {
    let requestId = null, lastArgs;
    const later = (context) => () => {
        requestId = null;
        callback.apply(context, lastArgs);
    };
    const throttled = (...args) => {
        lastArgs = args;
        if (requestId === null) {
            requestId = requestAnimationFrame(later(this));
        }
    };
    throttled.cancel = () => {
        cancelAnimationFrame(requestId);
        requestId = null;
    };
    return throttled;
}

// Megamenu
class MegaShopMenu {
    constructor() {
        this.initMenuItems();
        this.initSubmenuLinks();
    }

    initMenuItems() {
        document.querySelectorAll('.mega-shop__menu-item[data-megashop-parent]').forEach(item => {
            item.addEventListener('mouseover', e => {
                // e.preventDefault();
                this.clearActiveMenuItems();
                item.classList.add('active');

                if (e.target.closest('.mega-shop__menu-link') || e.target.classList.contains('mega-shop__menu-link')) {
                    let subCollection = item.querySelector('.mega-shop__submenu-link').getAttribute('data-collection');
                    this.toggleMegamenuCollection(subCollection);
                }
            });
        });
    }

    initSubmenuLinks() {
        document.querySelectorAll('.mega-shop__submenu-link').forEach(link => {
            link.addEventListener('click', e => {
                if (window.innerWidth <= 1100) return;

                e.preventDefault();
                let collection = link.getAttribute('data-collection');
                this.toggleMegamenuCollection(collection);
            });
        });
    }

    clearActiveMenuItems() {
        document.querySelectorAll('.mega-shop__menu-item[data-megashop-parent]').forEach(el => {
            el.classList.remove('active');
        });
    }

    toggleMegamenuCollection(collection) {
        document.querySelectorAll('.mega-shop__products').forEach(el => {
            el.classList.remove('active');
        });
        document.querySelector(`.mega-shop__products[data-collection="${collection}"]`)?.classList.add('active');

        document.querySelectorAll('.mega-shop__submenu-link').forEach(el => {
            el.classList.remove('active');
            if (el.getAttribute('data-collection') === collection) {
                el.classList.add('active');
            }
        });
    }
}

class HeaderScrollHandler {
    constructor() {
        this.header = document.querySelector('header');
        this.announcement = document.querySelector('.shopify-section--announcement');
        if (this.header) {
            this.lastScrollPosition = window.scrollY;
            this.throttledUpdate = throttle(this.updateHeader.bind(this));
            this.updateHeader();
            window.addEventListener('scroll', this.throttledUpdate, {passive: true});
        }
    }

    updateHeader() {
        const currentScrollPosition = window.scrollY;
        if (currentScrollPosition > 0 || (currentScrollPosition === 0 && this.announcement?.classList.contains('hidden'))) {
            this.header.classList.add('scrolled');
        } else {
            this.header.classList.remove('scrolled');
        }
        this.lastScrollPosition = currentScrollPosition;
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new MegaShopMenu();
    new HeaderScrollHandler();
});

// Mobile Menu
class MobileMenu {
    constructor() {
        this.menuToggle = document.querySelectorAll('[data-toggle-mobile-menu]');
        this.mobileMenu = document.querySelector('.m-menu');
        this.backBtn = document.querySelector('.m-menu__back');
        this.logo = document.querySelector('.m-menu__logo');
        this.title = document.querySelector('.m-menu__title');
        this.init();
    }

    init() {
        this.menuToggle.forEach(toggle => {
            toggle.removeEventListener('click', toggle._mobileMenuHandler || (() => {
            }));
            toggle._mobileMenuHandler = this.toggleMenu.bind(this);
            toggle.addEventListener('click', toggle._mobileMenuHandler);
        });

        document.querySelectorAll('.m-menu__link[data-megamenu-parent]').forEach(link => {
            link.removeEventListener('click', link._megaMenuHandler || (() => {
            }));
            link._megaMenuHandler = (e) => {
                e.preventDefault();
                let parent = link.getAttribute('data-megamenu-parent');
                document.querySelector(`.megamenu[data-megamenu="${parent}"]`).classList.add('active');
                this.activeMobileMega(link.getAttribute('data-title'));
            };
            link.addEventListener('click', link._megaMenuHandler);
        });

        document.querySelectorAll('.mega-shop__menu-item[data-megashop-parent]').forEach(item => {
            item.removeEventListener('click', item._megaShopHandler || (() => {
            }));
            item._megaShopHandler = (e) => {
                e.preventDefault();
                let parent = item.getAttribute('data-megashop-parent');
                let submenu = document.querySelector(`.mega-shop__submenu[data-submenu="${parent}"]`);
                let linksSize = submenu.getAttribute('data-links-size');
                submenu.classList.add('active-mobile');
                this.activeMobileMega(item.getAttribute('data-title'));
                if(linksSize == 1) {
                    submenu.querySelector('.mega-shop__submenu-link').click();
                }
            };
            item.addEventListener('click', item._megaShopHandler);
        });

        document.querySelectorAll('.mega-shop__submenu-link[data-collection]').forEach(link => {
            link.removeEventListener('click', link._submenuHandler || (() => {
            }));
            link._submenuHandler = (e) => {
                if (window.innerWidth > 1100) return;

                e.preventDefault();
                let collection = link.getAttribute('data-collection');
                document.querySelector(`.mega-shop__products[data-collection="${collection}"]`).classList.add('active-mobile');
                setTimeout(() => {
                    this.activeMobileMega(link.getAttribute('data-title'));
                }, 1);
            };
            link.addEventListener('click', link._submenuHandler);
        });

        if (this.backBtn) {
            this.backBtn.removeEventListener('click', this.backBtn._backHandler || (() => {
            }));
            this.backBtn._backHandler = this.handleBack.bind(this);
            this.backBtn.addEventListener('click', this.backBtn._backHandler);
        }
    }

    toggleMenu() {
        if (this.mobileMenu.classList.contains('active')) {
            this.closeAllMegamenus();
        }
        this.mobileMenu.classList.toggle('active');
        document.body.classList.toggle('no-scroll');
    }

    activeMobileMega(title) {
        this.logo.classList.remove('active');
        this.backBtn.classList.add('active');
        this.title.classList.add('active');
        this.title.innerHTML = title;
    }

    closeAllMegamenus() {
        document.querySelectorAll('.megamenu').forEach(menu => {
            menu.classList.remove('active');
        });
        document.querySelectorAll('.mega-shop__products').forEach(menu => {
            menu.classList.remove('active-mobile');
        });
        document.querySelectorAll('.mega-shop__submenu').forEach(menu => {
            menu.classList.remove('active-mobile');
        });
        this.logo.classList.add('active');
        this.backBtn.classList.remove('active');
        this.title.classList.remove('active');
    }

    handleBack(e) {
        e.preventDefault();
        let activeProducts = document.querySelector('.mega-shop__products.active-mobile');
        let activeSubmenu = document.querySelector('.mega-shop__submenu.active-mobile');
        let activeMega = document.querySelector('.megamenu.active');
        if (activeProducts) {
            activeProducts.classList.remove('active-mobile');
            let title = document.querySelector(`.mega-shop__menu-item.active`)?.getAttribute('data-title');
            this.activeMobileMega(title);
            let parentMenu = document.querySelector('.mega-shop__submenu.active-mobile')
            let linksSize = parentMenu.getAttribute('data-links-size');
            if(linksSize == 1) {
                parentMenu.classList.remove('active-mobile');
            }
        } else {
            if (activeSubmenu) {
                activeSubmenu.classList.remove('active-mobile');
                let title = document.querySelector(`.megamenu.active`)?.getAttribute('data-megamenu');
                this.activeMobileMega(title);
            } else if (activeMega) {
                activeMega.classList.remove('active');
                this.closeAllMegamenus();
            }
        }
    }
}

function initMobileMenu() {
    if (window.innerWidth <= 1100) {
        new MobileMenu();
    }
}

initMobileMenu();

window.addEventListener('resize', function () {
    initMobileMenu();
});

// Subcollection Products
document.addEventListener('DOMContentLoaded', function () {
    const collectionLinks = document.querySelectorAll('.collection__sublist-link');
    const collectionProducts = document.querySelectorAll('.collection__products-wrap');
    collectionLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const collectionHandle = this.getAttribute('data-subcollection');
            collectionLinks.forEach(l => l.classList.remove('is-active'));
            this.classList.add('is-active');

            collectionProducts.forEach(cp => {
                if (cp.getAttribute('data-subcollection') === collectionHandle) {
                    cp.classList.add('is-active');
                } else {
                    cp.classList.remove('is-active');
                }
            });
        });
    });
});

// Announcement Bar
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.announcement__close')) {
        const announcement = document.querySelector('.shopify-section--announcement');
        const header = document.querySelector('header');
        const closeBtn = announcement.querySelectorAll('[data-announcement="close"]');

        closeBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                announcement.classList.add('hidden');
                header.classList.add('scrolled');
            });
        });
    }
});

// Testimonials Slider
function initTestimonialsSwiper() {
    const testimonialSections = document.querySelectorAll('.testimonials-swiper__container');
    testimonialSections.forEach(section => {
        const mainSwiperEl = section.querySelector('.testimonials-swiper');
        const thumbsSwiperEl = section.querySelector('.testimonials-thumbs');
        if (!mainSwiperEl || !thumbsSwiperEl) return;

        const thumbsSwiper = new Swiper(thumbsSwiperEl, {
            slidesPerView: 3,
            spaceBetween: 8,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            direction: 'horizontal',
            breakpoints: {
                768: {
                    spaceBetween: 16
                }
            }
        });

        new Swiper(mainSwiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: section.querySelector('.testimonials-swiper-next'),
                prevEl: section.querySelector('.testimonials-swiper-prev')
            },
            autoplay: {
                delay: 7000,
                disableOnInteraction: true
            },
            thumbs: { swiper: thumbsSwiper },
            loop: true,
            autoHeight: true,
            grabCursor: true
        });
    });

    // Testimonial Show More/Less
    document.querySelectorAll('.testimonial-content').forEach(content => {
        const quote = content.querySelector('.testimonial-quote');
        const moreBtn = content.querySelector('.testimonial-info__more');
        const lessBtn = content.querySelector('.testimonial-info__less');
        if (!quote || !moreBtn || !lessBtn) return;

        quote.classList.remove('expanded');
        moreBtn.style.display = '';
        lessBtn.style.display = 'none';

        moreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelectorAll('.testimonial-quote.expanded').forEach(q => q.classList.remove('expanded'));
            document.querySelectorAll('.testimonial-info__less').forEach(b => b.style.display = 'none');
            document.querySelectorAll('.testimonial-info__more').forEach(b => b.style.display = '');
            quote.classList.add('expanded');
            moreBtn.style.display = 'none';
            lessBtn.style.display = '';

            setTimeout(() => {
                const swiperContainer = content.closest('.testimonials-swiper');
                if (swiperContainer && swiperContainer.swiper) {
                    swiperContainer.swiper.updateAutoHeight();
                    swiperContainer.swiper.update();
                }
            }, 50);
        });

        lessBtn.addEventListener('click', function(e) {
            e.preventDefault();
            quote.classList.remove('expanded');
            moreBtn.style.display = '';
            lessBtn.style.display = 'none';

            setTimeout(() => {
                const swiperContainer = content.closest('.testimonials-swiper');
                if (swiperContainer && swiperContainer.swiper) {
                    swiperContainer.swiper.updateAutoHeight();
                    swiperContainer.swiper.update();
                }
            }, 50);
        });
    });
}
document.addEventListener('DOMContentLoaded', initTestimonialsSwiper);

// Featured Collection Slider
function initCollectionSliderSwiper(selector) {
    const container = document.querySelector(selector);
    if (!container) return;

    new Swiper(container, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: '10%',
        loop: true,
        grabCursor: true,
        autoplay: {
            delay: 7000,
            disableOnInteraction: true
        },
        pagination: {
            el: container.querySelector('.swiper-pagination'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initCollectionSliderSwiper('.featured-collection-swiper');
});

// Collection Features Slider
function initFeaturesSwiper(el) {
    if (!el) return;

    let section = el.closest('.features');

    new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: '10%',
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        loopAdditionalSlides: true,
        autoplay: {
            delay: 7000,
            disableOnInteraction: true
        },
        navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            992: {
                spaceBetween: '24px',
                slidesPerView: 'auto'
            },
        },
        on: {
            slideChangeTransitionEnd: function (data) {
                let i = +section.querySelector('.swiper-slide.swiper-slide-active').getAttribute('data-slide');
                i = i < 10 ? '0' + i : i;
                section.querySelector('[data-current-slide]').innerHTML = i;
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.features__list').forEach(el => {
        initFeaturesSwiper(el);
    });
});

// Product Gallery
function initializeProductGallery() {
    const mediaSwiper = document.querySelector('.product-gallery__media-list-wrapper');
    const mediaSwiperEl = document.querySelector('.product-gallery__media-list');
    const thumbSwiperEl = document.querySelector('.product-gallery__thumbnail-list');

    if (!mediaSwiper || !mediaSwiperEl || !thumbSwiperEl) {
        return;
    }

    const slides = mediaSwiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) {
        console.warn('No slides found in media swiper');
        return;
    }
    
    // Destroy existing swipers if they exist
    if (thumbSwiperEl.swiper) {
        thumbSwiperEl.swiper.destroy(true, true);
    }
    if (mediaSwiperEl.swiper) {
        mediaSwiperEl.swiper.destroy(true, true);
    }
    
    const thumbSlides = document.querySelectorAll('.product-gallery__thumbnail-list .swiper-slide');
    const thumbsSwiper = new Swiper(thumbSwiperEl, {
        slidesPerView: 4,
        spaceBetween: 8,
        loop: thumbSlides.length > 6,
        breakpoints: {
            1300: {
                slidesPerView: 6,
            }
        }
    });

    function handleVideos(swiper) {
        // pause ALL videos first
        swiper.slides.forEach(slide => {
            const video = slide.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0; // optional (remove if you want resume)
            }
        });

        // play videos in ACTIVE slides (important for loop/duplicate slides)
        swiper.slides.forEach(slide => {
            if (slide.classList.contains('swiper-slide-active')) {
                const video = slide.querySelector('video');
                if (video) {
                    video.play().catch(() => {});
                }
            }
        });
    }

    window.productMediaSwiper = new Swiper(mediaSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 8,
        loop: true,
        on: {
            init: handleVideos,
            slideChangeTransitionEnd: handleVideos
        },
        thumbs: { swiper: thumbsSwiper },
        navigation: {
            nextEl: mediaSwiper.querySelector('.swiper-button-next'),
            prevEl: mediaSwiper.querySelector('.swiper-button-prev')
        }
    });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeProductGallery);

// Expose globally for re-initialization after AJAX updates
if (typeof window.reinitializeProductGallery === 'undefined') {
    window.reinitializeProductGallery = initializeProductGallery;
}

// Quantity Selector
var QuantitySelector = class extends HTMLElement {
    connectedCallback() {
        this._abortController = new AbortController();
        this.inputElement = this.querySelector("input");
        this.querySelector("button:first-of-type").addEventListener("click", this.stepDown.bind(this), { signal: this._abortController.signal });
        this.querySelector("button:last-of-type").addEventListener("click", this.stepUp.bind(this), { signal: this._abortController.signal });
    }
    stepDown() {
        this.inputElement.stepDown();
        this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }
    stepUp() {
        this.inputElement.stepUp();
        this.inputElement.dispatchEvent(new Event("change", { bubbles: true }));
    }
    disconnectedCallback() {
        this._abortController.abort();
    }
};
var QuantityInput = class extends HTMLInputElement {
    constructor() {
        super();
        this.addEventListener("input", this._onValueInput);
        this.addEventListener("change", this._onValueChanged);
        this.addEventListener("focus", this.select);
    }
    disconnectedCallback() {
        this._abortController?.abort();
    }
    get quantity() {
        return parseInt(this.value);
    }
    set quantity(quantity) {
        const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
        if (quantity === "") {
            return;
        }
        if (!isNumeric || quantity < 0) {
            quantity = parseInt(quantity) || 1;
        }
        this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
        if (!this.checkValidity()) {
            this.stepDown();
        }
    }
    _onValueInput() {
        this.quantity = this.value;
        this.style.setProperty("--quantity-input-characters-count", `${this.value.toString().length}ch`);
    }
    _onValueChanged() {
        if (this.value === "") {
            this.quantity = this.min || 1;
        }
        if (!this.checkValidity()) {
            this.stepDown();
        }
        this.style.setProperty("--quantity-input-characters-count", `${this.value.toString().length}ch`);
    }
};
if (!window.customElements.get("quantity-selector")) {
    window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
    window.customElements.define("quantity-input", QuantityInput, { extends: "input" });
}

// Anchored links
const anchoredLinks = document.querySelectorAll('.smooth-scroll');
anchoredLinks.forEach(function(link) {
    link.addEventListener('click', function (e) {
        const href = this.getAttribute('href');

        if (href && href.includes('#')) {
            const anchorId = href.split('#')[1];
            const targetElement = document.getElementById(anchorId);

            if (targetElement) {
                e.preventDefault();

                // Smooth scroll to the target element with 80px offset
                const offset = 80;
                const targetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });

                // Update URL without jumping
                if (history.pushState) {
                    history.pushState(null, null, '#' + anchorId);
                }
            }
        }
    });
});

// Parts Slider
function initPartsSwiper(swiperEl) {
    // Prevent re-initialization if already initialized
    if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
    }
    
    new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slideToClickedSlide: true,
        breakpoints: {
            1200: {
                spaceBetween: 24
            },
            1600: {
                spaceBetween: 64
            }
        },
        navigation: {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
        }
    });
}

// Initialize all parts swipers - can be called multiple times
function initializePartsSwipers() {
    document.querySelectorAll('.parts-swiper').forEach(initPartsSwiper);
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializePartsSwipers);

// Expose globally for re-initialization after AJAX updates
if (typeof window.reinitializePartsSwipers === 'undefined') {
    window.reinitializePartsSwipers = initializePartsSwipers;
}

window.Shopify = window.Shopify || {};
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = format || this.money_format;
    function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        let parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    }
    let match = formatString.match(placeholderRegex);
    if (!match) return '';
    switch (match[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

// Recently Viewed
(function() {
    const RECENTLY_VIEWED_KEY = 'recently_viewed_products';
    const MAX_ITEMS = 3;

    function getRecentlyViewed() {
        try {
            return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
        } catch(e) {
            return [];
        }
    }
    function setRecentlyViewed(arr) {
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(arr));
    }

    document.addEventListener('DOMContentLoaded', function() {
        let productJson = window.meta && window.meta.product ? window.meta.product : (window.product || null);
        let handle = null;
        if (productJson && productJson.handle) {
            handle = productJson.handle;
        } else {
            let el = document.querySelector('[data-product-handle]');
            if (el) handle = el.getAttribute('data-product-handle');
        }
        if (handle) {
            let viewed = getRecentlyViewed();
            viewed = viewed.filter(h => h !== handle);
            viewed.unshift(handle);
            if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);
            setRecentlyViewed(viewed);
        }
    });

    async function renderRecentlyViewed() {
        const container = document.querySelector('.recently-viewed__products');
        if (!container) return;
        let max = parseInt(container.getAttribute('data-max-items'), 10) || MAX_ITEMS;
        let handles = getRecentlyViewed().slice(0, max);
        if (!handles.length) {
            container.innerHTML = '<div class="text-center text-muted">No recently viewed products.</div>';
            return;
        }
        container.innerHTML = '<div class="recently-viewed__loading">Loading...</div>';
        const products = await Promise.all(handles.map(async handle => {
            try {
                const res = await fetch(`/products/${handle}.js`);
                if (!res.ok) return null;
                return await res.json();
            } catch(e) {
                return null;
            }
        }));
        const validProducts = products.filter(Boolean);
        if (!validProducts.length) {
            container.innerHTML = '<div class="text-center">No recently viewed products.</div>';
            return;
        }
        container.innerHTML = '<div class="recently-viewed__list flex justify-center flex-wrap gap-4"></div>';
        const list = container.querySelector('.recently-viewed__list');
        validProducts.forEach(product => {

            const image = product.featured_image ? `<img src="${product.featured_image}" alt="${product.title}" class="w-full h-full object-cover" loading="lazy">` : `<img src="${window.Shopify?.routes?.host}/cdn/shop/files/product-image-placeholder.avif" alt="${product.title}" class="w-full h-full object-cover" loading="lazy">`;
            const url = product.url || `/products/${product.handle}`;
            list.insertAdjacentHTML('beforeend', `
                <div class="product-item">
                    <a href="${url}" class="product-item__img">${image}</a>
                    <div class="product-item__inner">
                        <div class="product-item__info">
                            <div class="product-item__title h4">${product.title}</div>
                        </div>
                        <a href="${url}" class="product-item__button button">VIEW DETAILS</a>
                    </div>
                </div>
            `);
        });
    }
    document.addEventListener('DOMContentLoaded', renderRecentlyViewed);
})();

// FAQ
function initFaq() {
    const tabs = document.querySelectorAll('.tabs__item');
    const contents = document.querySelectorAll('.tabs__content-item');
    
    if (tabs.length === 0) return;
    
    tabs.forEach(tab => {
        // Clone to remove old listeners
        const newTab = tab.cloneNode(true);
        tab.parentNode.replaceChild(newTab, tab);
        
        newTab.addEventListener('click', function () {
            const target = this.getAttribute('data-tab');
            document.querySelectorAll('.tabs__item').forEach(t => t.classList.remove('active'));
            contents.forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            const targetEl = document.getElementById(target);
            if (targetEl) {
                targetEl.classList.add('active');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initFaq);

// Expose globally for re-initialization
if (typeof window.reinitializeFaq === 'undefined') {
    window.reinitializeFaq = initFaq;
}

// Accordion
function initAccordion() {
    const items = document.querySelectorAll('.accordion__item');
    
    if (items.length === 0) return;
    
    items.forEach(item => {
        // Clone to remove old listeners
        const newItem = item.cloneNode(true);
        item.parentNode.replaceChild(newItem, item);
        
        newItem.addEventListener('click', function () {
            const content = this.querySelector('.accordion__content');
            if (content.style.height) {
                content.style.height = null;
                this.classList.remove('active');
            } else {
                content.style.height = content.scrollHeight + 'px';
                this.classList.add('active');
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initAccordion);

// Expose globally for re-initialization
if (typeof window.reinitializeAccordion === 'undefined') {
    window.reinitializeAccordion = initAccordion;
}

// Checkbox
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.form__checkbox-icon').forEach(function(icon) {
        icon.addEventListener('click', function(e) {
            e.preventDefault();
            const checkboxWrapper = icon.closest('.form__checkbox');
            if (!checkboxWrapper) return;
            const checkbox = checkboxWrapper.querySelector('input[type="checkbox"]');
            if (!checkbox) return;
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });
});

// Warranty Popup - Check if user is authorized dealer
document.addEventListener('DOMContentLoaded', function () {
    const warrantyButton = document.getElementById('warrantyPopup');
    
    if (!warrantyButton) {
        return;
    }
    
    // Store the original href and remove it to prevent navigation
    const originalHref = warrantyButton.getAttribute('href');
    warrantyButton.removeAttribute('href');
    warrantyButton.style.cursor = 'pointer';
    
    warrantyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Check if customer data is available (set by Liquid template)
        const isLoggedIn = window.customerLoggedIn || false;
        const customerTags = window.customerTags || [];
        
        // Check if user has 'dealer' tag
        const hasDealer = customerTags.some(tag => tag.toLowerCase() === 'dealer');
        
        if (isLoggedIn && hasDealer) {
            // User is authorized, proceed to warranty page
            window.location.href = originalHref;
        } else {
            // User is not logged in or doesn't have dealer tag
            showWarrantyPopup();
        }
        
        return false;
    }, true);
    
    function showWarrantyPopup() {
        // Create popup overlay
        const overlay = document.createElement('div');
        overlay.id = 'warranty-popup-overlay';
        overlay.className = 'vehicle-popup-overlay';
        overlay.style.display = 'flex';
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        
        // Create popup content
        const popup = document.createElement('div');
        popup.className = 'vehicle-popup-content';
        
        popup.innerHTML = `
            <div class="vehicle-popup-header">
                <div>Authorization Required</div>
            </div>
            <div class="vehicle-popup-body">
                <p>
                    Only authorized Massimo Service Providers can submit warranty claims. 
                    If you need to find an authorized service provider, 
                    <a href="/pages/find-a-service-center" style="color: #080001; text-decoration: underline;">click here</a>. 
                    If you are an authorized service provider, please 
                    <a href="/customer_authentication/login?return_to=${encodeURIComponent('/pages/account')}" style="color: #080001; text-decoration: underline;">Log In</a>.
                </p>
            </div>
            <div class="vehicle-popup-footer">
                <button class="button w-full text-uppercase" id="warranty-popup-close">Close</button>
            </div>
        `;
        
        overlay.appendChild(popup);
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        
        // Add animation class
        setTimeout(() => {
            overlay.classList.add('show');
        }, 10);
        
        // Close popup handlers
        const closePopup = function() {
            overlay.classList.remove('show');
            setTimeout(() => {
                if (overlay.parentNode) {
                    document.body.removeChild(overlay);
                }
                document.body.style.overflow = '';
            }, 300);
        };
        
        document.getElementById('warranty-popup-close').addEventListener('click', closePopup);
        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) {
                closePopup();
            }
        });
    }
});

// Search Overlay
class SearchOverlay {
    constructor() {
        this.overlay = document.querySelector('[data-search-overlay]');
        this.toggleBtn = document.querySelector('[data-toggle-search]');
        this.closeBtn = document.querySelector('[data-close-search]');
        this.searchInput = document.querySelector('[data-search-input]');
        this.resultsContainer = document.querySelector('[data-search-results-content]');
        this.loadingEl = document.querySelector('[data-search-loading]');
        this.noResultsEl = document.querySelector('[data-search-no-results]');
        this.searchTimeout = null;
        
        if (!this.overlay || !this.toggleBtn) return;
        
        this.init();
    }
    
    init() {
        // Toggle search overlay
        this.toggleBtn.addEventListener('click', () => this.open());
        
        // Close search overlay
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }
        
        // Close on overlay click
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.close();
            }
        });
        
        // Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.overlay.classList.contains('active')) {
                this.close();
            }
        });
        
        // Search input handler with debounce
        if (this.searchInput) {
            this.searchInput.addEventListener('input', (e) => {
                clearTimeout(this.searchTimeout);
                const query = e.target.value.trim();
                
                if (query.length >= 2) {
                    this.searchTimeout = setTimeout(() => {
                        this.performSearch(query);
                    }, 300);
                } else {
                    this.clearResults();
                }
            });
        }
    }
    
    open() {
        this.overlay.classList.add('active');
        document.body.classList.add('no-scroll');
        
        // Focus on input after animation
        setTimeout(() => {
            if (this.searchInput) {
                this.searchInput.focus();
            }
        }, 300);
    }
    
    close() {
        this.overlay.classList.remove('active');
        document.body.classList.remove('no-scroll');
        this.clearResults();
        if (this.searchInput) {
            this.searchInput.value = '';
        }
    }
    
    showLoading() {
        if (this.loadingEl) {
            this.loadingEl.removeAttribute('hidden');
        }
        if (this.noResultsEl) {
            this.noResultsEl.setAttribute('hidden', '');
        }
        this.resultsContainer.innerHTML = '';
    }
    
    hideLoading() {
        if (this.loadingEl) {
            this.loadingEl.setAttribute('hidden', '');
        }
    }
    
    clearResults() {
        this.resultsContainer.innerHTML = '';
        this.hideLoading();
        if (this.noResultsEl) {
            this.noResultsEl.setAttribute('hidden', '');
        }
    }
    
    async performSearch(query) {
        this.showLoading();
        
        try {
            // Search using the external API
            const response = await fetch('https://faas-fra1-afec6ce7.doserverless.co/api/v1/web/fn-8eb821f9-1a94-483a-8c89-558689d7b534/node-fetch/search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    searchTerm: query
                })
            });
            
            const products = await response.json();
            
            this.hideLoading();
            
            if (products && products.length > 0) {
                this.displayResults(products);
            } else {
                this.showNoResults();
            }
        } catch (error) {
            console.error('Search error:', error);
            this.hideLoading();
            this.showNoResults();
        }
    }
    
    displayResults(products) {
        this.resultsContainer.innerHTML = products.map(product => {
            // Format price - Shopify Predictive Search returns price as string
            const price = product.price || '0.00';
            const imageUrl = product.image || '';
            const placeholderUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cdn/shop/files/product-image-placeholder.avif` : '';
            
            // Generate responsive image srcset if image exists
            let imageHtml = '';
            if (imageUrl) {
                // Extract base URL without size parameters
                const baseUrl = imageUrl.split('?')[0];
                const imageSrcset = `
                    ${baseUrl}?width=200 200w,
                    ${baseUrl}?width=400 400w,
                    ${baseUrl}?width=600 600w,
                    ${baseUrl}?width=800 800w
                `;
                imageHtml = `
                    <img 
                        src="${baseUrl}?width=400" 
                        srcset="${imageSrcset}"
                        sizes="(max-width: 600px) 200px, (max-width: 1200px) 400px, 800px"
                        alt="${product.title}" 
                        class="search-result-item__image"
                        loading="lazy"
                    >
                `;
            } else if (placeholderUrl) {
                imageHtml = `<img src="${placeholderUrl}" alt="${product.title}" class="search-result-item__image" loading="lazy">`;
            } else {
                imageHtml = '<div class="search-result-item__image"></div>';
            }
            
            // Display SKU
            const skuHtml = product.sku ? `<div class="search-result-item__sku">SKU: ${product.sku}</div>` : '';
            
            return `
                <div class="search-result-item">
                    <a href="${product.link}" class="search-result-item__link">
                        ${imageHtml}
                        <div class="search-result-item__content">
                            <div class="search-result-item__title">${product.title}</div>
                            <div class="search-result-item__price">$${price}</div>
                            ${skuHtml}
                        </div>
                    </a>
                </div>
            `;
        }).join('');
    }
    
    showNoResults() {
        if (this.noResultsEl) {
            this.noResultsEl.removeAttribute('hidden');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new SearchOverlay();
});
